import axios from 'axios'

axios.interceptors.request.use(config => {
  // loading
  return config
}, error => {
  return Promise.reject(error)
});

axios.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.resolve(error.response)
});

var host = `${process.env.HOST}`
var post = `${process.env.PORT}`
var baeurl=`${process.env.BASURL}`
const base = "https://" + host + ":" + post//测试服务器
export default {
  getBaseUrl() {
    return baeurl
  },
  login(val, params) {
    const url = base + val.url;
    return axios({
      method: val.method,
      url,
      data: params,
      timeout: 60000,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Access-Control-Allow-Origin': "*",
        "Access-Control-Allow-Methods": "*",
        "Access-Control-Allow-Headers": "*",
        "access-control-allow-origin": "*"
      }
    }).then(
      (response) => {
        return response.data
      }
    )
  },
  httpServer(opts, data) {
    let token = localStorage.getItem("token")
    var Authorization=token?"Token " + token:""
    const url = base + opts.url;
    let httpDefaultOpts = ''
    if (opts.method === 'POST' || opts.method === 'PUT' || opts.method === "PATCH") {
      httpDefaultOpts = {
        method: opts.method,
        url: url,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Access-Control-Allow-Origin': "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Credentials": "true",
          "Authorization": Authorization
        },
        timeout: 60000,
        data: data
      }
    } else {
      httpDefaultOpts = {
        method: opts.method,
        url: url,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Access-Control-Allow-Origin': "*",
          "Access-Control-Allow-Methods": "*",
          "Access-Control-Allow-Headers": "*",
          "Access-Control-Allow-Credentials": "true",
          "Authorization": Authorization
        },
        timeout: 60000,
        params: data
      }
    }
    return new Promise(function (resolve, reject) {
      axios(httpDefaultOpts).then(
        (res) => {
          if (res.status == 401) {
            localStorage.clear();
            location.href = '/'
            //Message.warning("登录过期，请重新进入")
          } else {
            resolve(res.data)
          }
        }
      ).catch(
        (err) => {
          console.log(err)
          reject(err.data)
        }
      )
    })
  }
}



// WEBPACK FOOTER //
// ./src/api/apiUtils.js